// EPM QA Checklist configuration and helpers
// Checklist templates are stored dynamically per-organization in the database (epm_checklists).

export const CHECKLIST_PROFILE = 'Standard A/B';

/** Required items only: what the gate counts. */
export const requiredCount = (items = []) =>
    items.filter((item) => (item.isRequired !== undefined ? item.isRequired : item.required)).length;

/** Normalizes a checklist item to standard UI fields (id, label, detail, required) */
export const normalizeChecklistItem = (item) => ({
    id: item._id || item.id,
    label: item.name || item.label || '',
    detail: item.description || item.detail || '',
    required: item.isRequired !== undefined ? item.isRequired : Boolean(item.required),
    env: item.env || 'STAGING',
    ...item,
});
